import { accountStreamerLookupSchema, type AccountStreamer } from '@growup/streaming-shared';
import { Button, Card, Notice, StatusBadge } from '@growup/ui';
import { useEffect, useState } from 'react';

import { getJson, messageOf } from '../api';
import { formatDateTime } from '../format';
import { STREAMER_LOOK } from '../streaming/labels';
import { StreamerDashboardCard } from '../streaming/StreamerDashboardCard';

/**
 * Na ficha de socio, quando a conta e (ou foi) streamer da Grow uP: canal,
 * estado e, para o Gestor de Streaming, o painel com os numeros da Twitch.
 * Quem nao e streamer nao ve nada.
 */
export function StreamerCard({
  accountId,
  canSeeNumbers,
  onOpenStreamer,
}: {
  accountId: string;
  canSeeNumbers: boolean;
  onOpenStreamer?: ((accountId: string) => void) | undefined;
}) {
  const [streamer, setStreamer] = useState<AccountStreamer | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getJson(`/api/streaming/accounts/${accountId}/streamer`, accountStreamerLookupSchema)
      .then((r) => setStreamer(r.streamer))
      .catch((e: unknown) => setError(messageOf(e)));
  }, [accountId]);

  if (error) return <Notice tone="danger">Streamer: {error}</Notice>;
  if (!streamer) return null;
  const look = STREAMER_LOOK[streamer.status];

  return (
    <>
      <Card
        headingLevel={2}
        title="Streamer"
        eyebrow={`Na equipa desde ${formatDateTime(streamer.joinedAt)}`}
        actions={<StatusBadge tone={look.tone}>{look.label}</StatusBadge>}
      >
        <p className="break-words text-gu-ink-muted">
          {streamer.displayName} ·{' '}
          <a
            className="gu-link"
            href={`https://www.twitch.tv/${streamer.channel}`}
            target="_blank"
            rel="noreferrer"
          >
            twitch.tv/{streamer.channel}
          </a>
        </p>
        {onOpenStreamer ? (
          <Button
            variant="secondary"
            size="sm"
            className="self-start"
            onClick={() => onOpenStreamer(accountId)}
          >
            Abrir em Streaming
          </Button>
        ) : null}
      </Card>
      {canSeeNumbers && streamer.status !== 'removed' ? (
        <StreamerDashboardCard streamerId={streamer.id} />
      ) : null}
    </>
  );
}
